import { TaskItem } from '../App';

const AVATAR_COLORS = [
  '#4CAF50', '#2196F3', '#FF9800', '#E91E63',
  '#9C27B0', '#00BCD4', '#FF5722', '#607D8B'
];

export interface PersonWithCount {
  email: string;
  userId: string;
  photoURL?: string;
  taskCount: number;
}

export function getAvatarColor(email: string): string {
  const charCode = email.toLowerCase().charCodeAt(0);
  return AVATAR_COLORS[charCode % AVATAR_COLORS.length];
}

export function getInitials(email: string): string {
  const parts = email.split('@')[0].split(/[._-]/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return email.slice(0, 2).toUpperCase();
}

export function aggregatePeopleFromTasks(tasks: TaskItem[]): PersonWithCount[] {
  const peopleMap = new Map<string, PersonWithCount>();

  for (const task of tasks) {
    if (!task.sharedWith) continue;

    for (const user of task.sharedWith) {
      const existing = peopleMap.get(user.userId);
      if (existing) {
        existing.taskCount++;
        // Update photoURL if we have one now
        if (user.photoURL && !existing.photoURL) {
          existing.photoURL = user.photoURL;
        }
      } else {
        peopleMap.set(user.userId, {
          email: user.email,
          userId: user.userId,
          photoURL: user.photoURL,
          taskCount: 1,
        });
      }
    }
  }

  // Sort by task count (descending), then alphabetically by email
  return Array.from(peopleMap.values()).sort((a, b) => {
    if (b.taskCount !== a.taskCount) {
      return b.taskCount - a.taskCount;
    }
    return a.email.localeCompare(b.email);
  });
}
